module.exports = __webpack_public_path__ + "media/images/common/ico-resultchk-caf118c4a9c6c049aa1a7c18a729b319.svg";